import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as style from './ScoreLineShared.module.less';
export type ScoreLinePosition = 'under' | 'over' | 'in-range';

export type ScoreEntry = {
    score: number;
    type: ScoreLinePosition;
};

export type ScoreDisplay = {
    min: string;
    max: string;
    centerText?: string;
    value: string;
};

interface IScoreLineProps {
    className?: string;
    entries: ScoreEntry[];
    display: ScoreDisplay;
}
export const ScoreLineRanged = observer((p: IScoreLineProps) => {
    const minValue = p.display.min;
    const maxValue = p.display.max;
    const valDisplay = p.display.value;

    //score range is 0 to 1

    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling

    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const redCls = style.tooltipRed;
    const yellowCls = style.tooltipYellow;
    const greenCls = style.tooltipGreen;

    const entries = p.entries.map((entry, i) => {
        var classTooltip = null;
        var posX = -1;
        if (entry.type == 'under') {
            posX = halfEdge;
            classTooltip = redCls;
        } else if (entry.type == 'over') {
            posX = 1 - halfEdge;
            classTooltip = greenCls;
        } else {
            posX = edge + entry.score * (1 - edge * 2);
            classTooltip = null;
            var scoreInt = parseInt((entry.score * 100).toString());
            if (scoreInt > 85) {
                classTooltip = greenCls;
            } else if (scoreInt > 55) {
                classTooltip = yellowCls;
            } else {
                classTooltip = redCls;
            }
        }

        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = classNames(
            style.scoreLineEntry,
            classTooltip,
            style.tooltip_tip
        );
        return (
            <div key={i} className={cls} style={{ left: posXStr }}>
                {valDisplay}
            </div>
        );
    });

    const cls = classNames(
        style.scoreLine,
        style.scoreLineRangedGradient,
        p.className
    );
    return (
        <>
            <div className={style.scoreLineContainer}>
                <div className={cls}>
                    <div className={style.leftLabel}>{minValue}</div>
                    <div className={style.rightLabel}>{maxValue}</div>
                    <div className={style.centerLabel}>
                        {p.display.centerText}
                    </div>
                    <div className={style.edgeLineGreen}></div>
                    <div className={style.edgeLineRed}></div>
                    {entries}
                </div>
            </div>
        </>
    );
});
